<template>
  <div v-if="$route.query.file" class="view-book-page">
    <view-book></view-book>
  </div>
  <div v-else>
    <div>
      <h4 class="about-title">
        {{ currentMenu.menuTitle !== false ? currentMenu.menuTitle : ls_AllBooks }}
      </h4>
    </div>
    <b-row class="products ctrl-dir">
      <b-col class="products-content" cols="8">
        <b-card v-if="bookList.length > 0">
          <p v-if="currentMenu.description" class="product-content-description">
            {{ currentMenu.description }}
          </p>
          <div v-else class="book-list">
            <b-row class="ctrl-dir">
              <b-col v-for="(book, index) in bookList" :key="index" cols="6">
                <b-media no-body class="book-list-item">
                  <b-media-aside vertical-align="center">
                    <b-img :src="host + book.thumbnailUrl" width="105" height="160" alt="placeholder" />
                  </b-media-aside>
                  <b-media-body class="ml-3">
                    <h5 class="book-title">{{ book.title }}</h5>
                    <p class="book-tool book-publish-time"><i class="book-tool-square fas fa-square-full"></i> {{ book.publishYear }}</p>
                    <p class="book-tool book-author"><i class="book-tool-square fas fa-square-full"></i> {{ book.author }}</p>
                    <p class="book-tool book-type"><i class="book-tool-square fas fa-square-full"></i> {{ book.bookType }}</p>
                    <b-button
                      @click="showBook(book)"
                      class="book-read">
                      <i class="book-read-icon fab fa-readme"></i> {{ ls_Read }}
                    </b-button>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </div>
        </b-card>
        <b-card v-else>
          <p v-if="currentMenu.description" class="product-content-description">
            {{ currentMenu.description }}
          </p>
          <div class="book-list">
            <h6 class="no-data"><i class="far fa-info-circle"></i> {{ ls_ThisPageHasNoData }}</h6>
          </div>
        </b-card>
        <b-pagination
          v-if="totalPage > 1"
          class="rounded-pagination"
          size="sm"
          v-model="pageIndex"
          :per-page="pageSize"
          :total-rows="totalBooks"
          align="center"
          :prevText="ls_Prev"
          :nextText="ls_Next"
          :limit="limit"
          :hideGotoEndButtons="hideFirstLastBtn">
        </b-pagination>
      </b-col>
      <b-col class="products-sidebar" cols="4">
        <sidebar-menu
          :menuTitle="ls_BooksMenu"
          :menuList="booksMenuList"
          :currentMenu="currentMenu">
        </sidebar-menu>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ViewBook from "./ViewBook.vue";
import SidebarNavigation from "@/components/navigation/SidebarNavigation.vue";

export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 6,
      totalBooks: 0,
      totalPage: 0,
      limit: 4,
      hideFirstLastBtn: true,

      defaultMenu: {
        id: 0,
        description: "",
        menuTitle: false,
        url: "/products"
      },
      currentMenu: {},
      booksMenuList: [],
      bookList: []
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    // booksMenuList() {
    //   let menuInStore = this.$store.state.navigationList;
    //   let currentMenu
    // },
    ls_Prev() {
      return this.$store.state.languagePack.ls_Prev;
    },
    ls_Next() {
      return this.$store.state.languagePack.ls_Next;
    },
    ls_AllMenus() {
      return this.$store.state.languagePack.ls_AllMenus;
    },
    ls_AllBooks() {
      return this.$store.state.languagePack.ls_AllBooks;
    },
    ls_BooksMenu() {
      return this.$store.state.languagePack.ls_BooksMenu;
    },
    ls_Read() {
      return this.$store.state.languagePack.ls_Read;
    },
    ls_ThisPageHasNoData() {
      return this.$store.state.languagePack.ls_ThisPageHasNoData;
    },
    currentMenuId() {
      return this.$route.query.mId !== undefined
        ? parseInt(this.$route.query.mId)
        : this.currentMenu.id;
    }
  },

  created() {
    let currentMenuId = this.$route.query.mId;
    currentMenuId = currentMenuId !== undefined ? parseInt(currentMenuId) : 0;
    this.getBooksMenuList(currentMenuId);

    let thisPage = this.$route.query.page;
    thisPage = thisPage !== undefined ? parseInt(thisPage) : 1;
    this.pageIndex = thisPage;

    this.getBookList(thisPage, this.pageSize, this.$route.query.mId);
  },

  watch: {
    $route(newVal, oldVal) {
      if (newVal.query && newVal.query.file !== undefined) return;
      if (newVal === oldVal) return;
      if (parseInt(newVal.query.mId) >= 0) {
        this.currentMenu = this.booksMenuList.filter(
          m => m.id === parseInt(newVal.query.mId)
        )[0];
        if (newVal.query.page === undefined) {
          this.pageIndex = 1;
          this.getBookList(1, this.pageSize, parseInt(newVal.query.mId));
        } else {
          this.getBookList(
            parseInt(newVal.query.page),
            this.pageSize,
            parseInt(newVal.query.mId)
          );
        }
      } else {
        this.currentMenu = this.defaultMenu;
        if (newVal.query.page === undefined) {
          this.pageIndex = 1;
          this.getBookList(1, this.pageSize, 0);
        } else {
          this.getBookList(parseInt(newVal.query.page), this.pageSize, 0);
        }
      }

      if (newVal.params.ln !== oldVal.params.ln) {
        let currentMenuId = this.$route.query.mId;
        currentMenuId =
          currentMenuId !== undefined ? parseInt(currentMenuId) : 0;
        this.getBooksMenuList(currentMenuId);
        this.getBookList(
          parseInt(newVal.query.page),
          this.pageSize,
          parseInt(newVal.query.mId)
        );
      }
    },

    pageIndex: function(newVal, oldVal) {
      if (newVal.query && newVal.query.file !== undefined) return;
      if (newVal === oldVal) return;
      if (this.$route.query.mId === undefined) {
        this.$router.push({
          path: this.$route.path,
          query: {
            page: newVal
          }
        });
      } else {
        this.$router.push({
          path: this.$route.path,
          query: {
            mId: parseInt(this.$route.query.mId),
            page: newVal
          }
        });
      }
    }
  },

  methods: {
    urlPrefixer(url) {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln + url
        : url;
    },

    toViewBook(book) {
      this.$router.push({
        path:
          this.$route.params.ln !== undefined
            ? "/" + this.$route.params.ln + "/products"
            : "/products",
        query: {
          file: book.id + ".pdf"
        }
      });
    },

    getBooksMenuList(currentMenuId) {
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getbooksmenulist", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.booksMenuList = result.body.data.dataList;
              this.booksMenuList.unshift(this.defaultMenu);
              if (currentMenuId === 0) {
                this.currentMenu = this.defaultMenu;
              } else {
                this.currentMenu = this.booksMenuList.filter(
                  m => m.id === currentMenuId
                )[0];
              }
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },

    getBookList(pageIndex, pageSize, mId) {
      this.$store.state.loading = true;
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("page", pageIndex);
      fd.append("pageSize", pageSize);
      fd.append("mId", mId);
      this.$http
        .post(this.host + "/api/qazlatyn/getbooklist", fd)
        .then(result => {
          this.$store.state.loading = false;
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.totalPage = result.body.data.totalPage;
              this.totalBooks = result.body.data.total;
              this.bookList = result.body.data.dataList;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },

    showBook(book) {
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("id", book.id);
      this.$http
        .post(this.host + "/api/qazlatyn/getbook", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.$router.push({
                query: {
                  file: book.id + '.pdf'
                }
              });
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  components: {
    "view-book": ViewBook,
    "sidebar-menu": SidebarNavigation
  },

  metaInfo() {
    return {
      title: this.ls_BooksMenu
    };
  }
};
</script>

<style lang="scss" scoped>
.products {

  .products-content {

    .card {
      border-radius: 0;

      .card-body {
        padding-bottom: 0.375rem;
      }
    }

    .products-content-title {
      font-family: 'Open Sans', sans-serif;
      font-size: 1.75rem;
      color: #221f20;
      font-weight: 600;
    }

    .product-content-description {
      font-family: 'Open Sans', sans-serif;
      font-size: 0.875rem;
      color: #606161;
      margin-bottom: 1.875rem;
    }

    .book-list {
      .book-list-item {
        position: relative;
        padding: 0.625rem;
        border: 1px solid #f1f2f2;
        border-radius: 0.25rem;
        margin-bottom: 0.875rem;

        .book-title {
          color: #221f20;
          font-size: 1rem;
          font-family: 'Open Sans', sans-serif;
          border-bottom: 1px solid #e7e7e7;
          padding-bottom: 0.5rem;
        }

        .book-tool {
          color: #969596;
          font-size: 0.75rem;
          margin-bottom: 0.25rem;

          .book-tool-square {
            font-size: 0.375rem;
          }
        }

        .book-author {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }

        .book-read {
          position: absolute;
          bottom: 0.625rem;
          right: 0.625rem;
          font-size: 0.875rem;
          padding: 0.375rem 0.75rem;
          border: 0;
          color: #ffffff;
          font-family: 'Open Sans', sans-serif;
          background-color: #008496;

          .book-read-icon {
            margin-right: 0.5rem;
          }

          &:hover {
            background-color: #006b75;
            color: #f6f6f6;
          }
        }
      }
    }
  }
}
.no-data {
  padding: 1rem 0;
  color: #959595;
}
/* RTL */

.rtl-layout .products {
  .product-content-description {
    direction: rtl;
    text-align: right;
  }

  .book-list {
    .ctrl-dir {
      direction: rtl;
    }
  }

  .book-list-item {
    direction: rtl;

    .media-body {
      margin-left: 0 !important;
      margin-right: 15px;

      * {
        direction: rtl;
        text-align: right;
      }
    }

    .book-read {
      right: calc(100% - 0.625rem);
      left: 0.625rem;
      direction: rtl;

      i {
        margin-right: 0 !important;
        margin-left: 5px;
      }
    }
  }
}
</style>
